import {useLayoutEffect} from 'react';
import {connect} from 'react-redux';
import * as actions from './AxiosSetupActions';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';

const AxiosSetup = ({actions}) => {
    useLayoutEffect(() => {
        const object = queryString.parse(location.search ? location.search.split('?')[1] : '');
        const token = object.token;
        if (token) {
            actions.login({id: 0, access_token: token});
            actions.mockProfile();
        }
        actions.setupAxios();
    }, []);

    return '';
};

AxiosSetup.propTypes = {
    actions: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(undefined, mapDispatchToProps)(AxiosSetup);


// WEBPACK FOOTER //
// ./src/containers/template/AxiosSetup.js